<template>
	<div class="login">
		<lazy-background class="login-background" src="/images/home-background.jpg">
			<div class="form-holder">
				<loader :loading="loading"></loader>
				<transition name="fade" mode="out-in">
					<login-form key="login-form" v-if="!resetting && !forgot && !user" @submit="login" @forgot="forgot = true" @loading="loading = $event"></login-form>
					<send-reset-form key="reset-form" v-else-if="!resetting && forgot && !user" @back="forgot = false" @loading="loading = $event"></send-reset-form>
					<reset-password-form key="reset-password-form" v-else-if="resetting" @loading="loading = $event"></reset-password-form>
				</transition>
			</div>
		</lazy-background>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				forgot: false,
				user: null,
				resetting: false
			};
		},
		watch: {
			'$route.path': function() {
				if(this.$route.path === '/reset-password') {
					this.resetting = true;
				} else {
					this.resetting = false;
				}
			},
			async resetting() {
				if(this.resetting && !this.$route.query.key) {
					try {
						await this.$navigate('/');
					} catch(e) {}
					
				}
				try {
					const reset = await this.$post('/json/reset-password', {key: this.$route.query.key});
				} catch(e) {
					try {
						await this.$navigate('/');
					} catch(e) {}
				}
			}
		},
		methods: {
			login(event) {
				this.loading = false;
				this.$store.state.user = new User(event.user);
			}
		},
		mounted() {
			if(this.$route.path === '/reset-password') {
				this.resetting = true;
			}
		}
	}
</script>